<a (click)="delete()" class="fa fa-times text-danger" title="Remove{{ itemType ? ' ' + itemType : '' }}"></a>